var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1007 228.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #72cbef;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.05,186.91h62.26v20.73H26.31V20.85h20.74v62.26h62.26v20.79h-62.26v83ZM109.31,186.91v-83h20.74v83h-20.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.02,207.64V20.85h20.74v186.79h-20.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.72,41.64v-20.79h20.74v20.79h-20.74ZM202.72,207.64v-124.52h20.74v124.52h-20.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.15,103.91h20.74v20.73h-20.74v83h-20.73v-124.53h20.73v20.79ZM290.88,103.91v-20.79h41.53v20.79h-41.53ZM332.41,207.65v-103.73h20.74v103.73h-20.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.12,186.91v-83h20.74v83h-20.74ZM482.86,20.85v186.79h-83v-20.73h62.26v-83h-62.26v-20.79h62.26V20.85h20.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M586.39,41.64v41.47h20.74v20.79h-20.74v103.73h-20.73V41.64h20.73ZM586.39,41.64v-20.79h20.74v20.79h-20.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M633.1,186.91v-41.53h20.74v41.53h-20.74ZM653.83,103.91v-20.79h62.26v20.79h-62.26ZM736.83,103.91v103.73h-83v-20.73h62.26v-41.53h-62.26v-20.74h62.26v-20.73h20.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M762.81,41.64v-20.79h20.74v20.79h-20.74ZM762.81,207.64v-124.52h20.74v124.52h-20.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M830.24,103.91v83h-20.74V41.65h20.74v41.47h20.74v20.79h-20.74ZM830.24,207.65v-20.74h20.74v20.74h-20.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M897.69,103.91h20.74v20.73h-20.74v83h-20.74V20.86h20.74v83.05ZM918.43,103.91v-20.79h41.53v20.79h-41.53ZM959.95,207.65v-103.73h20.74v103.73h-20.74Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7acd4f955aab7b4164aaddada3b02e47.svg";
export { ForwardRef as ReactComponent };